<template>
  <el-aside
    class="z-aside"
    :class="[collapsed && 'z-sider--collapsed']"
    :width="realWidth"
  >
    <slot></slot>
  </el-aside>
</template>

<script>
export default {
  name: 'ZAside',
  props: {
    width: {
      type: String,
      required: false,
      default: '256px',
    },
    collapsedWidth: {
      type: String,
      required: false,
      default: '64px'
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  computed: {
    realWidth () {
      if (this.collapsible && this.collapsed) {
        return this.collapsedWidth
      } else {
        return this.width
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.z-aside {
  transition: width 0.3s ease-in-out;
}
</style>
